import Api from 'utils/api'

export const fetchCandidates = ({ id }) => Api.get(['candidates', id])
